import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../auth.service';
import { Subscription, } from 'rxjs';
import { FlowComponent } from '../controls/flow/flow.component';
import { UIToast, UIToastComponent, UIToastRef } from '@irohalab/deneb-ui';
import { UpdateVerificationFlowBody, VerificationFlow } from '../../../sdk/kratos';
import { HttpErrorResponse } from '@angular/common/http';
import { MiraLogoComponent } from '../../ui/mira-logo/mira-logo.component';
import { ThemeToggleComponent } from '../../ui/theme-toggle/theme-toggle.component';

@Component({
    selector: 'app-verification',
    imports: [
      MiraLogoComponent,
      ThemeToggleComponent,
        FlowComponent,
        RouterLink
    ],
    templateUrl: './verification.component.html',
    styleUrl: './verification.component.less'
})
export class VerificationComponent implements OnInit, OnDestroy {
  private toastRef!: UIToastRef<UIToastComponent>;
  private subscription = new Subscription();

  flow?: VerificationFlow;

  protected get captchaEnabled(): boolean {
    return this.flow?.state !== 'passed_challenge';
  }

  protected get deferCaptcha(): boolean {
    return this.flow?.state === 'sent_email';
  }

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              toast: UIToast) {
    this.toastRef = toast.makeText();
  }

  ngOnDestroy(): void {
    console.log('onDestroy Verification');
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    console.log('onInit Verification');
    if (this.flow) {
      return;
    }
    const paramMap = this.activatedRoute.snapshot.queryParamMap;
    const flowId = paramMap.get('flow') || undefined;
    const returnTo = paramMap.get('return_to') || undefined;
    this.subscription.add(
      this.authService.createOrGetVerificationFlow(flowId, returnTo)
        .subscribe({
          next: (data) => {
            this.flow = data;
          },
          error: (err: any) => {
            console.log(err);
          }
        })
    );
  }

  onSubmit(values: UpdateVerificationFlowBody): void {
    // updateFlowIdWithoutRefresh(String(this.flow?.id));
    this.subscription.add(
      this.authService.updateVerificationFlow(values, String(this.flow?.id))
        .subscribe({
          next: (data) => {
            this.flow = data;
          },
          error: (err: HttpErrorResponse) => {
            switch (err.status) {
              case 400:
                // Status code 400 implies the form validation had an error
                if ((err.error as VerificationFlow).ui) {
                  this.flow = err.error as VerificationFlow;
                  return;
                }
                break;
              case 410:
                const newFlowId = err.error.use_flow_id;
                this.flow = undefined;
                return this.router.navigate([], {
                  queryParams: {flow: newFlowId}
                });
            }

            if (err.error.message) {
              this.toastRef.show(err.error.message);
            } else {
              console.log(err);
            }
            return;
          }
        })
    );
  }

}
